import React from 'react';

import Slider from 'rc-slider';

import 'rc-slider/assets/index.css';

type Marks = Record<number, string>;

const generateMarks = (numberOfSteps: number): Marks => {
  const marks = [...Array(numberOfSteps).keys()]
    .map(i => `${i + 1}`)
    .reduce<Marks>((acc, curent, i) => {
      acc[i + 1] = curent;
      return acc;
    }, {});

  return marks;
};

interface IProps {
  numberOfSteps: number;
  onChange?: (value: number | number[]) => void;
}

export const StepsSlider = ({ numberOfSteps, onChange }: IProps) => (
  <div className="select-none">
    <Slider min={1} max={numberOfSteps} marks={generateMarks(numberOfSteps)} onChange={onChange} />
  </div>
);
